import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

import icon1 from '../../theme/assets/other/lp_academy_s2_icon1.png';
import icon2 from '../../theme/assets/other/lp_academy_s2_icon2.png';

const AcademyS2 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTextWrap}`}>
                            <div className={`${Styles.contentBoxItemTextTitle}`}><span>{t('Об Академии:')}</span></div>
                            <div className={`${Styles.contentBoxItemTextBox}`}>
                                <div className={`${Styles.contentBoxItemText}`}>{t('Академия — это стратегическая точка входа в экосистему передовых технологий OMT. Мы не просто знакомим с блокчейном — мы формируем системное понимание рынка, инструментов и механизмов, которые позволяют действовать безопасно, инновационно и прибыльно.')}</div>
                                <div className={`${Styles.contentBoxItemText}`}>{t('Наша команда аналитиков изучила опыт более 100 000 человек в криптопространстве, выявив ключевые ошибки, приводящие к потерям капитала и времени. Мы создали образовательную систему, которая устраняет эти риски и формирует подготовленных, дисциплинированных и стратегически мыслящих участников рынка.')}</div>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemImgWrap}`}>
                            <img src={icon1} alt={t('Об Академии:')}/>
                        </div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTextWrap}`}>
                            <div className={`${Styles.contentBoxItemTextTitle}`}>{t('Наша')} <span>{t('главная цель:')}</span></div>
                            <div className={`${Styles.contentBoxItemTextBox}`}>
                                <div className={`${Styles.contentBoxItemText}`}>{t('Наша главная задача — соединить сильные проекты с сильными людьми, создавая пространство роста, эффективности и устойчивого результата для каждого участника экосистемы.')}</div>
                                <div className={`${Styles.contentBoxItemText}`}>{t('Мы даём людям доступ к лучшим проектам через знания, аналитику и технологическую инфраструктуру. И одновременно мы формируем для проектов качественное, обученное и осознанное сообщество.')}</div>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemImgWrap}`}>
                            <img src={icon2} alt={t('')}/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AcademyS2;




